<template>
  <section class="assessmentSection">
    <ProgressBar :value="15" />
    <div class="pageContent mb-12">
      <div class="pageTitle">
        Let’s talk about
        <br />cameras and video
      </div>

      <div class="text-bold">Benefits of cameras and video</div>
      <div
        class="mb-4"
      >Cameras allow you to peak in and see whats going on live. They also capture clips based on events like motion or doors opening.</div>

      <div class="text-bold">Cameras are not a replacement for security.</div>
      <div
        class="mb-4"
      >While cameras are great, they should not be relied upon for intrusion events.</div>
    </div>

    <div class="bg-blue-lightest equipment-section">
      <div class="pageContent">
        <div class="pageTitle productSectionTitle">
          Upgrade my system
          <br />with cameras and video
        </div>
        <EquipmentInfoWithQuantity :equipment="equipment" @change="handleEquipmentChange" />
      </div>
    </div>

    <div class="continue-section">
      <continue-button text="Continue" :to="continueTo" />
      <ModuleNeedHelp />
    </div>

  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import formatCurrency from "../Libraries/formatCurrency";
import ProgressBar from "../components/ProgressBar.vue";
import EquipmentInfoWithQuantity from "../components/EquipmentInfoWithQuantity.vue";
import ModuleNeedHelp from "../components/ModuleNeedHelp.vue";

export default {
  components: {
    ProgressBar,
    EquipmentInfoWithQuantity,
    ModuleNeedHelp,
  },
  data: () => ({
    descriptionVisibilities: [false, false],
    equipment: [],
    continueTo: `/assessment/system`
  }),
  methods: {
    setEquipment() {
      let equipment = [
        this.$store.getters.equipmentByName("Pulse Indoor Camera"),
        this.$store.getters.equipmentByName("Doorbell Camera")
      ];

      equipment = equipment.map(e => {
        e.quantity = this.$store.state.lead.automationQuantities[e.lead_key];
        e.subtotal = this.calculateSubtotal(e);
        return e;
      });

      this.equipment = equipment;
    },

    calculateSubtotal(equipment) {
      let quantity = equipment.quantity;
      let price = equipment.price;
      let total = quantity * price;
      let formatted = formatCurrency(total).replace(".00", "");

      return formatted;
    },

    handleEquipmentChange(newEquipment) {
      this.equipment = newEquipment;
    },

    handleContinue() {
      alert("ontinue");
    }
  },
  mounted() {
    this.$store.watch(state => {
      if (state.equipment.length && !this.equipment.length) {
        this.setEquipment();
      }
    });

    if (this.$store.state.lead.protectionLevel === "total") {
      this.continueTo = "/assessment/home-automation";
    }
  }
};
</script>

<style src="./AssessmentModule.css" scoped></style>
<style src="../../sass/components/continue-section.css" scoped></style>
